module.exports = __webpack_public_path__ + "media/images/empty/information-89ef32a09a27c07bef615658f81fd24c.svg";